<template>
  <div :bordered='false'>
    <div class='table-page-search-wrapper'>
      <a-form layout='inline' @keyup.enter.native='searchQuery'>
        <a-row :gutter='24'>
          <a-col :md='6' :sm='8'>
            <a-form-item :label="'Phone'">
              <a-input
                :placeholder="$t('enter') + ' Phone' "
                v-model='queryParam.mobileNo' />
            </a-form-item>
          </a-col>
          <a-col :md='6' :sm='8'>
            <a-form-item :label="'Batch No.'">
              <a-input
                :placeholder="$t('enter') + ' Batch No.' "
                v-model='queryParam.appSsid' />
            </a-form-item>
          </a-col>
          <a-col :md='6' :sm='8'>
            <span style='float: left;overflow: hidden;' class='table-page-search-submitButtons'>
              <a-button type='primary' @click='searchQuery' icon='search'>{{ $t('search') }}</a-button>
              <a-button type='primary' @click='handleDetail' icon='edit' style='margin-left: 8px'>{{ $t('edit') }}</a-button>
              <a-button type='primary' @click='searchReset' icon='reload' style='margin-left: 8px'>{{ $t('reset') }}</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
      <a-table
        ref='table'
        rowKey='id'
        size='middle'
        :columns='columns'
        :dataSource='dataSource'
        :pagination='false'
        :loading='loading'
        bordered>
      </a-table>

      <a-modal v-model='visdialog' title='Modify Order Overdue Days' @ok='handleOk' width='1000px'>
        <a-form :loading='loading' :form='orderInfoForm' :label-col='{ span: 5 }' :wrapper-col='{ span: 18 }'>
          <a-form-item :label="'Order ID'">
            <a-input disabled='disabled' v-model='orderInfoForm.id'></a-input>
          </a-form-item>
          <a-form-item :label="'Overdue Days'">
            <a-input v-model='orderInfoForm.overdueDays'></a-input>
          </a-form-item>
        </a-form>
      </a-modal>

    </div>
  </div>
</template>

<script>
import moment from 'moment'
import { getCustOrderDetail } from '@/webpublicapi/customer'
import { updateOverdueDaysById } from '@/webpublicapi/order'
import config from '@/config/common.json'

const I18N_KEY = 'order.'

export default {
  name: 'CustExtOrder',
  data() {
    return {
      visdialog: false,
      I18N_KEY,
      // Pagination params
      dataSource: [],
      // Query conditions
      queryParam: {
        'mobileNo': undefined,
        'appSsid': undefined
      },
      orderInfoForm: {
        id: undefined,
        overdueDays: undefined
      },
      loading: false,
      labelCol: {
        xs: { span: 8 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 16 },
        sm: { span: 19 }
      }
    }
  },
  computed: {
    columns() {
      return [
        {
          title: 'Column Name',
          align: 'left',
          width: '150px',
          dataIndex: 'left'
        },
        {
          title: 'Value',
          align: 'left',
          width: '150px',
          dataIndex: 'right'
        }
      ]
    }
  },
  created() {
    // this.loadData()
  },
  methods: {
    searchQuery() {
      this.loadData()
    },
    loadData() {
      this.loading = true
      var appSsid = this.queryParam.appSsid
      var mobileNo = this.queryParam.mobileNo
      getCustOrderDetail(appSsid, mobileNo).then((res) => {
        if (res.code === 1000) {
          this.dataSource = []
          for (let i in res.data) {
            if (i.indexOf('time') != -1 || i.indexOf('birthday') != -1) {
              res.data[i] = this.transformTime(res.data[i])
            }
            if (i == 'order_info.id') {
              this.orderInfoForm.id = res.data[i]
            }
            if (i == 'order_info.overdue_days') {
              this.orderInfoForm.overdueDays = res.data[i]
            }
            let dictElement = config.dict[i];
            if(process.env.VUE_APP_CONFIG == "jn"){
              dictElement = config.jn_dict[i];
            } else if(process.env.VUE_APP_CONFIG == "zaf"){
              dictElement = config.dict_zaf[i];
            }
            if (dictElement){
              res.data[i] = res.data[i] + (/^\d+$/.test(res.data[i]) ? "(Valid)":"(Invalid)")
            }

            let trans = config.trans[i];
            if(process.env.VUE_APP_CONFIG == "zaf"){
                trans = config.trans_zaf[i];
            }

            if (trans){
              let obj = {
                left: trans,
                right: res.data[i]
              }
              this.dataSource.push(obj)
            }
          }
        } else {
          this.dataSource = []
          this.$message.error(res.msg)
        }
        this.loading = false
      }).catch(e => {
        this.loading = false
        this.$message.error(e.message)
      })
    },
    transformTime(time) {
      return moment(time).format('YYYY-MM-DD')
    },
    // Reset dictionary type search box content
    searchReset() {
      var that = this
      that.queryParam.appSsid = ''
      that.queryParam.mobileNo = ''
      this.orderInfoForm.id =undefined,
      this.orderInfoForm.overdueDays =undefined,
      this.dataSource = []
    },
    handleDetail() {
      if (this.orderInfoForm.id == undefined) {
        this.$message.error('Please query order!')
      } else {
        this.visdialog = true
        this.loading = false
      }
    },
    handleOk() {
      updateOverdueDaysById(this.orderInfoForm.id, this.orderInfoForm.overdueDays).then(res => {
        if (res.code === 1000) {
          this.$message.success(this.$t('success'))
          this.orderInfoForm = {
            id: undefined,
            overdueDays: undefined
          }
          this.visdialog = false
          this.loadData()
        } else {
          this.$message.error(res.msg)
        }
      })
    }
  }
}
</script>
<style lang='less' scoped>
@import "~@/assets/less/common.less";
</style>
